import { getLatestDataUpdatedAt } from "@faire/help-center-utils/lib/getLatestDataUpdatedAt";
import { localeString } from "@faire/help-center-utils/lib/localeString";
import fetchZendeskSectionArticlesBySectionId, {
  build as SectionArticlesRequestKey,
} from "@faire/web-api--source/endpoints/www/api/zendesk/locale/sections/sectionId/articles/get";
import { IZendeskSection } from "@faire/web-api--source/com/faire/vendor/zendesk/IZendeskSection";
import { useQueries } from "@tanstack/react-query";

export const useAllSectionArticles = (sections: IZendeskSection[]) => {
  const sectionArticlesResponses = useQueries({
    queries: sections.map((section: IZendeskSection) => {
      return {
        queryKey: [SectionArticlesRequestKey(localeString, `${section.id}`)],
        queryFn: () =>
          fetchZendeskSectionArticlesBySectionId(localeString, `${section.id}`),
        enable: sections.length > 0 && !!section.id,
      };
    }),
  });
  const isLoading = sectionArticlesResponses.some(
    (queryResult) => queryResult.isLoading
  );

  const allDataUpdatedAt = sectionArticlesResponses.map(
    (queryResult) => queryResult.dataUpdatedAt
  );
  const dataUpdatedAt = getLatestDataUpdatedAt(allDataUpdatedAt);

  return {
    sectionArticlesResponses,
    isSectionArticlesLoading: isLoading,
    sectionArticlesDataUpdatedAt: dataUpdatedAt,
  };
};
